/* Chill Street WELCOME10 — email subscription + phone collection, no SMS opt-in. */
(() => {
  'use strict';
  const dialog = document.querySelector('[data-cs-popup]');
  const node = document.getElementById('cs-popup-config');
  if (!dialog || !node || dialog.dataset.initialized) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  if (!config.enabled) return;
  dialog.dataset.initialized = 'true';
  const demo = config.demo === true;
  const validId = value => typeof value === 'string' && /^[a-zA-Z0-9]{6}$/.test(value);
  if (!demo && ![config.companyId, config.emailListId].every(validId)) {
    console.warn('Chill Street popup: configure Public Site ID and Email List ID.');
    return;
  }

  const $ = selector => dialog.querySelector(selector);
  const hideKey = 'cs-welcome10-hide-until-v1';
  const completedKey = 'cs-welcome10-completed-v2';
  let step = 1, occasion = '', email = '', busy = false;
  let completedInMemory = false, previousFocus, oldOverflow;
  const title = $('#cs-title');
  const subtitle = $('#cs-subtitle');
  const error = $('#cs-error');
  const phoneForm = $('[data-cs-phone-form]');
  if (!phoneForm) {
    console.warn('Chill Street popup: replace the Liquid snippet with the phone-only version.');
    return;
  }

  function completed() {
    if (completedInMemory) return true;
    try { if (localStorage.getItem(completedKey) === '1') return true; } catch {}
    try { return document.cookie.split(';').some(value => value.trim() === `${completedKey}=1`); }
    catch { return false; }
  }
  function markCompleted() {
    // Demo must never mark a visitor as having actually completed a signup.
    if (demo) return;
    completedInMemory = true;
    try { localStorage.setItem(completedKey, '1'); } catch {}
    try {
      document.cookie = `${completedKey}=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure`;
    } catch {}
  }
  function hiddenUntil() {
    try { return Number(localStorage.getItem(hideKey)) || 0; } catch { return 0; }
  }
  function snooze() {
    if (demo || completed()) return;
    try {
      localStorage.setItem(hideKey, String(Date.now() + (config.dismissDays || 7) * 86400000));
    } catch {}
  }
  function showError(message) {
    error.textContent = message;
    error.hidden = false;
  }
  const titles = [null, ["You've Got", '10% Off!'], ["You've Got", '10% Off'], ['One Last Step'], ['Your 10% Off Is Ready!']];
  const subtitles = [null, 'What are you drinking for?', 'Enter your email to lock in your discount', 'Add your phone number to complete your signup', 'Use WELCOME10 at checkout.'];
  function render(next, focus = true) {
    step = next;
    dialog.querySelectorAll('[data-cs-panel]').forEach(panel => {
      panel.hidden = Number(panel.dataset.csPanel) !== step;
    });
    title.replaceChildren(document.createTextNode(titles[step][0]));
    if (titles[step][1]) {
      const strong = document.createElement('strong');
      strong.textContent = titles[step][1];
      title.append(document.createElement('br'), strong);
    }
    subtitle.textContent = subtitles[step];
    $('[data-cs-step-label]').textContent = step === 4 ? 'WELCOME TO CHILL STREET' : `STEP ${step} OF 3`;
    $('.cs-progress').setAttribute('aria-label', `Step ${Math.min(step, 3)} of 3`);
    dialog.querySelectorAll('.cs-progress span').forEach((el, index) => {
      el.classList.toggle('cs-active', index < step);
    });
    error.hidden = true;
    dialog.scrollTop = 0;
    if (focus && dialog.open) title.focus({preventScroll: true});
  }
  function open() {
    // Recheck when opening, including manual buttons and delayed callbacks.
    if (completed() || dialog.open || !dialog.showModal) return;
    previousFocus = document.activeElement;
    oldOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    render(step);
  }
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow || '';
    snooze();
    previousFocus?.focus?.({preventScroll: true});
  });
  // Honor completion in another tab and hide an unfinished popup there.
  window.addEventListener('storage', event => {
    if (event.key === completedKey && event.newValue === '1' && dialog.open && step !== 4) dialog.close();
  });
  function setBusy(value) {
    busy = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('form button, form input, [data-cs-back]').forEach(el => {
      el.disabled = value;
    });
  }
  function normalizePhone(raw) {
    const value = raw.trim();
    if (!/^[+\d\s().-]+$/.test(value)) return null;
    let digits = value.replace(/\D/g, '');
    if (value.startsWith('+') && !value.startsWith('+1')) return null;
    if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? '+1' + digits : null;
  }
  async function request(endpoint, body, message) {
    if (demo) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(`https://a.klaviyo.com/client/${endpoint}?company_id=${encodeURIComponent(config.companyId)}`, {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify(body),
        signal: controller.signal,
        credentials: 'omit'
      });
      if (response.status === 429) throw new Error('Too many attempts. Please wait a minute before trying again.');
      if (!response.ok) throw new Error(message);
      // 202 means accepted for asynchronous processing, not confirmed consent.
    } catch (err) {
      if (err.name === 'AbortError') throw new Error('The request timed out. Please try again.');
      if (err instanceof TypeError) throw new Error('Unable to connect. Please check your connection and try again.');
      throw err;
    } finally { clearTimeout(timeout); }
  }
  function properties() {
    return {
      chillstreet_drinking_occasion: occasion,
      chillstreet_signup_source: 'welcome10-popup-phone-only-v2'
    };
  }
  async function subscribeEmail() {
    await request('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Chill Street WELCOME10 / email / disclosure-v1-20261008',
          profile: {data: {
            type: 'profile',
            attributes: {
              email,
              properties: properties(),
              subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
            }
          }}
        },
        relationships: {list: {data: {type: 'list', id: config.emailListId}}}
      }
    }, 'We could not submit your email signup. Please check your email or try again later.');
  }
  async function savePhone(phone) {
    await request('profiles', {
      data: {
        type: 'profile',
        attributes: {
          email,
          properties: {
            ...properties(),
            // Custom property: saves phone even when existing profile identifiers
            // cannot be changed through Klaviyo's client API. No SMS subscription.
            chillstreet_phone_number: phone,
            chillstreet_welcome10_claimed: true,
            chillstreet_welcome10_claimed_at: new Date().toISOString()
          }
        }
      }
    }, 'We could not save your phone number. Please try again.');
  }
  dialog.addEventListener('click', async event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-cs-close')) { dialog.close(); return; }
    if (busy) return;
    if (button.dataset.csOccasion) { occasion = button.dataset.csOccasion; render(2); }
    if (button.dataset.csBack) render(Number(button.dataset.csBack));
    if (button.hasAttribute('data-cs-copy')) {
      try { await navigator.clipboard.writeText('WELCOME10'); button.textContent = 'Copied!'; }
      catch { button.textContent = 'Copy manually: WELCOME10'; }
    }
  });
  $('[data-cs-email-form]').addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !occasion || !event.target.reportValidity()) return;
    email = $('#cs-email').value.trim();
    error.hidden = true;
    setBusy(true);
    try { await subscribeEmail(); render(3); }
    catch (err) { showError(err.message); }
    finally { setBusy(false); }
  });
  phoneForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !email || !event.target.reportValidity()) return;
    const phone = normalizePhone($('#cs-phone').value);
    if (!phone) { showError('Please enter a valid Canada or US phone number (+1).'); return; }
    error.hidden = true;
    setBusy(true);
    try {
      await savePhone(phone);
      markCompleted();
      render(4);
    } catch (err) { showError(err.message); }
    finally { setBusy(false); }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-cs-open]')) open();
  });
  render(1, false);
  if (!completed() && (demo || hiddenUntil() <= Date.now())) {
    setTimeout(open, Math.max(0, Number(config.delayMs) || 0));
  }
})();
